//#region Imports
import {
  assertBoolean,
  assertNullableNumber,
  assertNullableString,
  assertNumber,
  assertString,
  UserDetailsRecord,
} from "@anydo/core";
import type {
  IUserDetailsRecord,
  IUserDto,
  IUserWhatsAppPersonalRecord,
  IUserWhatsAppWorkspaceRecord,
} from "@anydo/interfaces";
//#endregion

//#region Helpers
function mapUserWhatsApp(serverProps: IUserDto["whatsapp"]): IUserWhatsAppPersonalRecord | null {
  if (serverProps == null) return null;
  const { isReminders, language } = serverProps;
  assertNumber(isReminders);

  return {
    /**
     * Server returns integer
     */
    isReminders: isReminders === 1,
    language: language ?? "en",
  };
}

function mapUserWorkspaceWhatsApp(serverProps: IUserDto["workspaceWhatsapp"]): IUserWhatsAppWorkspaceRecord | null {
  if (serverProps == null) return null;
  const { isReminders, isUserUpdates, isBoardUpdates, language } = serverProps;
  assertNumber(isReminders);
  assertNumber(isUserUpdates);

  return {
    /**
     * Server returns integer
     */
    isReminders: isReminders === 1,
    isUserUpdates: isUserUpdates === 1,
    isBoardUpdates: isBoardUpdates === 1,
    language: language ?? "en",
  };
}
//#endregion

export function getUserDetailsFromUserDto({
  creationDate,
  email,
  googleAvatarUrl,
  id,
  idSalt,
  name,
  profilePicture,
  onBoardingPending,
  timezone,
  verifiedPhoneNumber,
  whatsapp: propsWhatsapp,
  workspaceWhatsapp: propsWorkspaceWhatsapp,
  completedCounter,
  firstDayOfWeek,
  webConfig,
  myDayConfig,
  myDaySuggestionFilters,
  isPremium,
  isReverseTrial,
}: IUserDto): IUserDetailsRecord {
  assertNumber(creationDate);
  assertString(email);
  assertNullableString(googleAvatarUrl);
  assertString(id);
  assertString(idSalt);
  assertNullableString(name);
  assertNullableString(profilePicture);
  assertBoolean(onBoardingPending);
  assertNullableString(timezone);
  assertNullableString(verifiedPhoneNumber);
  const whatsapp = mapUserWhatsApp(propsWhatsapp);
  const workspaceWhatsapp = mapUserWorkspaceWhatsApp(propsWorkspaceWhatsapp);
  assertNullableNumber(completedCounter);
  assertNullableNumber(firstDayOfWeek);

  return UserDetailsRecord.create({
    creationDate,
    email,
    googleAvatarUrl,
    id,
    idSalt,
    name: name || "",
    profilePicture,
    onBoardingPending,
    timezone,
    verifiedPhoneNumber,
    whatsapp,
    workspaceWhatsapp,
    completedCounter,
    firstDayOfWeek,
    // `webConfig` cannot be typed checked. Since it has no structure in DB
    webConfig: webConfig ?? undefined,
    myDayConfig: myDayConfig ?? undefined,
    myDaySuggestionFilters: myDaySuggestionFilters ?? undefined,

    isPremium,
    isReverseTrial,
  });
}
